// Unpublished Work © 2025 Deere & Company.

import {CONFLICT} from 'Common/constants/errors';

const DUPLICATE_NAME_MESSAGE_FRAGMENT = 'name already exists';
const DUPLICATE_DATE_TIME_MESSAGE_FRAGMENT = 'already exists for this membership, date, and start time';

const DUPLICATE_ENTITY_TYPES = {
    TEMPLATE: 'template',
    WORKBOARD: 'workboard'
};

function normalizeName(value = '') {
    return String(value).trim().toLowerCase();
}

function getPayload(errorOrPayload) {
    if (errorOrPayload?.response?.data) {
        return errorOrPayload.response.data;
    }

    return errorOrPayload || {};
}

function getStatusCode(errorOrPayload) {
    if (errorOrPayload?.response?.status) {
        return errorOrPayload.response.status;
    }

    return errorOrPayload?.statusCode || errorOrPayload?.status || null;
}

function getDuplicateEntityType(payload) {
    const message = String(payload?.message || '').toLowerCase();

    if (message.includes(DUPLICATE_NAME_MESSAGE_FRAGMENT)) {
        return DUPLICATE_ENTITY_TYPES.TEMPLATE;
    }

    if (message.includes(DUPLICATE_DATE_TIME_MESSAGE_FRAGMENT)) {
        return DUPLICATE_ENTITY_TYPES.WORKBOARD;
    }

    return null;
}

function parseDuplicateConflict(errorOrPayload) {
    const payload = getPayload(errorOrPayload);
    const status = getStatusCode(errorOrPayload);
    const duplicateEntityType = status === CONFLICT ? getDuplicateEntityType(payload) : null;

    return {
        isDuplicateName: duplicateEntityType !== null,
        duplicateEntityType,
        payload
    };
}

function isDuplicateConflict(errorOrPayload) {
    return parseDuplicateConflict(errorOrPayload).isDuplicateName;
}

export {
    DUPLICATE_ENTITY_TYPES,
    normalizeName,
    parseDuplicateConflict,
    isDuplicateConflict
};
